import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoForward10 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.297 21.22c-.698 1-1.097 2.5-1.097 4.1 0 1.6.499 3.1 1.097 4.1.698 1 1.496 1.5 2.294 1.5s1.696-.5 2.294-1.5c.698-1 1.097-2.5 1.097-4.1 0-1.6-.498-3.1-1.097-4.1-.698-1-1.496-1.5-2.294-1.5-.698 0-1.596.5-2.294 1.5Zm-1.496-1c.898-1.3 2.294-2.3 3.89-2.3s2.992 1 3.89 2.3c.898 1.4 1.396 3.2 1.396 5.1 0 1.9-.498 3.8-1.396 5.1-.898 1.3-2.294 2.3-3.89 2.3s-2.992-1-3.89-2.3c-.898-1.4-1.396-3.2-1.396-5.1 0-1.9.498-3.8 1.396-5.1ZM17.113 18.12c.399.2.798.7.798 1.3v12.5c0 .5-.399.9-.898.9a.895.895 0 0 1-.897-.9v-12.1l-1.796.7c-.498.2-.997-.1-1.197-.5-.2-.5.1-1 .499-1.2l2.095-.8c.498-.2.997-.2 1.396.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M41.35 25.02c0 10.7-8.677 19.4-19.35 19.4-10.672 0-19.35-8.7-19.35-19.4S11.328 5.62 22 5.62h.4l-3.591-3.6c-.4-.3-.4-.9 0-1.3.399-.4.897-.4 1.296 0l5.187 5.2c.2.2.3.4.3.6 0 .3-.1.5-.3.7l-5.187 5.2c-.399.4-.897.4-1.296 0-.4-.4-.4-.9 0-1.3l3.59-3.7H22c-9.675 0-17.554 7.9-17.554 17.6 0 9.7 7.88 17.6 17.554 17.6 9.675 0 17.555-7.9 17.555-17.6 0-5.1-2.194-9.7-5.685-12.9-.4-.3-.4-.9-.1-1.3.399-.4.898-.4 1.297-.1 3.89 3.6 6.283 8.7 6.283 14.3Z"
  })));
});
GoForward10.displayName = 'GoForward10';
GoForward10.defaultProps = {
  'aria-label': 'GoForward10'
};
export default GoForward10;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/GoForward10.js
// module id = 3177
// module chunks = 11